import { $, must } from './dom.ts';

// The Java program returns on its stdout a complete Javascript program that
// can assume it's running in a window that has a single canvas object.
const inject = (code: string) => {
  // Do we need to reset the iframe? Maybe?
  const s = $('<script>', `"use strict";\n//# sourceURL=Java Output\n${code}\n`);
  must($<HTMLIFrameElement>('iframe').contentDocument, 'iframe document').documentElement.append(s);
};

export default inject;
